import { Link } from "react-router-dom";
import { Twitter, Youtube, Instagram, Twitch } from "lucide-react";
import Logo from "@/components/Logo";

const SOCIALS = [
  { icon: Twitter, label: "Twitter / X", id: "twitter" },
  { icon: Youtube, label: "YouTube", id: "youtube" },
  { icon: Instagram, label: "Instagram", id: "instagram" },
  { icon: Twitch, label: "Twitch", id: "twitch" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-turf/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="max-w-xs">
            <Logo />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              The flappy arcade soccer game. One thumb, endless glory. Coming soon to iOS and Android.
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-16 gap-y-3" data-testid="footer-nav">
            {[
              { to: "/", label: "Home" },
              { to: "/flappy-goal", label: "Flappy Goal" },
              { to: "/court-vision", label: "Court Vision" },
              { to: "/about", label: "About Us" },
              { to: "/contact", label: "Contact Us" },
              { to: "/download", label: "Download" },
              { to: "/privacy", label: "Flappy Goal Privacy" },
              { to: "/court-vision/privacy", label: "Court Vision Privacy" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-slate-400 hover:text-volt transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.id}
                href="#"
                aria-label={s.label}
                data-testid={`footer-social-${s.id}`}
                onClick={(e) => e.preventDefault()}
                className="w-10 h-10 rounded-full border border-line flex items-center justify-center text-slate-400 hover:text-volt hover:border-volt/50 transition-colors"
              >
                <s.icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-mono uppercase tracking-widest text-slate-500">
            © 2026 Flappy Goal. All rights reserved.
          </p>
          <p className="text-xs font-mono uppercase tracking-widest text-mint">
            Flap. Shoot. Score.
          </p>
        </div>
      </div>
    </footer>
  );
}
